import { css } from '@emotion/react';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
import { setOpacity } from 'styles/utils';
import { i18n } from 'lib/i18n';

import Button from 'components/shared/Button/Button';
import { getSupportMailto } from 'lib/paths';

const contactUsButtonCss = (colors: IColors) => css`
	width: 100%;

	&.MuiButton-root {
		background-color: ${setOpacity(colors.bg_text_primary || '', 0.37)};
		border-radius: 2px;
	}

	.MuiButton-label {
		a {
			color: ${colors.tx_white};
			font-size: 1.6rem;
			font-weight: bold;
		}
	}

	padding: 24px;
`;

const contactBtnCss = css`
	padding: 25px 0;
`;

const ContactUsButton = () => {
	const { colors } = useColors();
	const supportmailto = getSupportMailto();
	return (
		<div css={contactBtnCss}>
			<Button data-aid="button-ContactUsButton-contact" variant="contained" css={contactUsButtonCss(colors)}>
				<a target="_blank" rel="noreferrer" href={supportmailto}>
					{i18n.contact.contactUs}
				</a>
			</Button>
		</div>
	);
};

export default ContactUsButton;
